// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import PublicCourse from '../views/PublicCourse.vue'
import CoursesHome from '../views/CoursesHome.vue'
import CourseViewer from '../views/CourseViewer.vue'
import Purchase from '../views/Purchase.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import AdminEnrollEmail from '../views/AdminEnrollEmail.vue' // ⭐ 新增
import { isAuthed } from '../utils/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Home', component: Home },

    {
      path: '/public',
      name: 'PublicCourse',
      component: PublicCourse,
      meta: { hideNav: true, hideFooter: true }
    },

    { path: '/courses', name: 'CoursesHome', component: CoursesHome },

    {
      path: '/course/:id',
      name: 'CourseViewer',
      component: CourseViewer,
      meta: { requiresAuth: true }
    },

    { path: '/purchase', name: 'Purchase', component: Purchase, meta: { noBg: true }},

    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, _from, next) => {
        if (isAuthed()) {
          const target = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
          next(target)
        } else {
          next()
        }
      }
    },

    { path: '/register', name: 'Register', component: Register },
    { path: '/forgot', name: 'Forgot', component: ForgotPassword },
    { path: '/reset/:token?', name: 'ResetPassword', component: ResetPassword },

    // ⭐ 新增路由（管理員手動授權頁）
    {
      path: '/admin/enroll-email',
      name: 'AdminEnrollEmail',
      component: AdminEnrollEmail,
      meta: { requiresAuth: true }
    }
  ],
  scrollBehavior: () => ({ top: 0 })
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthed()) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
